import React, { useEffect } from "react";
import { Row, Col, Input, Label } from "reactstrap";

import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { posApi, selectPosById, setPos, deleteTempPos} from "../reducers/posSlice";
import UserAutosuggest from "../../user/views/components/UserAutosuggest";
import SaveButton from "../../common/views/SaveButton";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

const PointOfSale = () => {
  const navigate = useNavigate()
  const roleName = useSelector((state) => state.identityReducer?.identity?.role?.label?.toUpperCase() );

  let { id } = useParams()
  if(id === undefined) id = 0;

  const dispatch = useDispatch()
  const pos = useSelector((state) => selectPosById(state, id));
  const status = useSelector((state) => state.posReducer.status);
  const error = useSelector((state) => state.posReducer.error);
  const lastSavedPos = useSelector((state) => state.posReducer.lastSavedPos);

  useEffect(() => {
    if(id > 0) {
      dispatch(posApi.fetchById({id: id}))
    }
  }, [id, dispatch])

  useEffect(() => {
    if(status === 'pos/create/succeeded' && lastSavedPos !== null) {
      // history.push('/pos/'+lastSavedPos.id)
      navigate('/pos/'+lastSavedPos.id)
    }
  }, [navigate, status, lastSavedPos])

  const onSavePosClick = () => {
    console.log(id, pos);
    if(id > 0) {
      dispatch(posApi.update({id: parseInt(id), pos: pos}))
    } else {
      dispatch(deleteTempPos())
      dispatch(posApi.create({pos: pos}))
    }
  }

  const showServerErrors = (field) => {
    if ((status === 'pos/create/rejected' || status === 'pos/update/rejected') && error !== null && error.message[field] !== undefined) {
      return <div className="error mb-2">
        <span className="error">
          * {error.message[field]}
          <br />
        </span>
      </div>;
    }
  };

  const ckBoxStyle = { marginRight: '5px', height: '20px', width: '20px', position: 'relative', top: '-4px'}

  return (
    <div className="app-drawer">
        <div className="app-drawer-content">
          <Row className="pb-2 px-2">
              <Col md="9" className="text-left" style={{display: 'flex'}}>
                <Label style={{whiteSpace: 'nowrap', paddingTop: '9px', paddingRight: '10px', fontWeight: 'bold'}}>Assistente di rete</Label>
                <UserAutosuggest
                  style={{width: '300px'}} 
                  readOnly={roleName === 'MEMBER'}
                  user={pos ? pos.user ? pos.user : null : null} 
                  onItemSelected={(user) => { 
                    dispatch(setPos({...pos, id: parseInt(id), user_id: user ? user.id : null})) 
                  }} />
              </Col>
              <Col md="3" style={{paddingRight: '5px'}}>
                  <div className="float-end">
                    <SaveButton 
                      id="save_pos_btn" 
                      color="primary" 
                      onClick={onSavePosClick} 
                      iconClassName="fas fa-check"
                      loadingIconClassName="fas fa-circle-notch fa-spin"
                      errorIconClassName="fas fa-exclamation-triangle"
                      label="SALVA PdV"
                      startLoadingCriteria={ ((status === 'pos/create/pending' || status === 'pos/update/pending'))}
                      endLoadingCriteria={ ((status === 'pos/create/succeeded' || status === 'pos/update/succeeded'))}
                      errorLoadingCriteria={ ((status === 'pos/create/rejected' || status === 'pos/update/rejected'))}
                      confirmMessage={"Point of Sale saved with success!"}
                    />
                  </div>
              </Col>

          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
              <Col md="12" className="text-left">
                <h4>ANAGRAFICA PUNTO VENDITA</h4>
              </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="1" xs="12">
              <Label>Codice</Label>
              <Input type="text" id="code" name="code" placeholder="Code" value={pos ? pos.code ? pos.code : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), code: e.target.value}))
                  }}
              />
              {showServerErrors("code")}
            </Col>

            <Col md="2" xs="12">
              <Label>Tipo cliente</Label>
              <Input type="select" id="type" value={pos ? pos.type ? pos.type : 0 : 0} 
                onChange={(e) => dispatch(setPos({...pos, id: parseInt(id), type: e.target.value}))} >
                  <option value="">Seleziona una tipologia ...</option>
                  <option value="ORDINARI">ORDINARI</option>
                  <option value="ORDINARI (C&C)">ORDINARI (C&C)</option>
                  <option value="ORDINARI (DSF)">ORDINARI (DSF)</option>
                  <option value="ORDINARI (SOM)">ORDINARI (SOM)</option>
                  <option value="PRIMARI">PRIMARI</option>
                  <option value="PRIMARI (AD HOC)">PRIMARI (AD HOC)</option>
                  <option value="PRIMARI (DSF)">PRIMARI (DSF)</option>
                  <option value="PRIMARI (SOM)">PRIMARI (SOM)</option>
              </Input>
            </Col>
            <Col md="3" xs="12">
              <Label>Insegna</Label>
              <Input type="text" id="sign" name="sign" placeholder="Sign" value={pos ? pos.sign ? pos.sign : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), sign: e.target.value}))
                  }}
              />
            </Col>
            <Col md="3" xs="12">
              <Label>Gruppo</Label>
              <Input type="text" id="group" name="group" placeholder="Group" value={pos ? pos.group ? pos.group : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), group: e.target.value}))
                  }}
              />
            </Col>
            <Col md="3" xs="12">
              <Label>Data di apertura (yyyy-mm-dd)</Label>
              <Datetime
                dateFormat="YYYY-MM-DD"
                timeFormat={false}
                value={pos ? pos.open_at ? pos.open_at : "" : ""}
                inputProps={{ placeholder: "seleziona una data..." }}
                onChange={(value) => {
                  dispatch(setPos({...pos, id: parseInt(id), open_at: value.format("YYYY-MM-DD")}))
                }}
              />

              {showServerErrors("open_at")}
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="9" xs="12">
              <Label>Indirizzo</Label>
              <Input type="text" id="address" name="address" placeholder="Address" value={pos ? pos.address ? pos.address : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), address: e.target.value}))
                  }}
              />
            </Col>
            <Col md="1" xs="4">
              <Label>Num.</Label>
              <Input type="text" id="address_number" name="address_number" placeholder="Num." value={pos ? pos.address_number ? pos.address_number : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), address_number: e.target.value}))
                  }}
              />
            </Col>
            <Col md="2" xs="8">
              <Label>Cap</Label>
              <Input type="text" id="cap" name="cap" placeholder="Cap" value={pos ? pos.cap ? pos.cap : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), cap: e.target.value}))
                  }}
              />
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="4" xs="12">
              <Label>Comune</Label>
              <Input type="text" id="city" name="city" placeholder="City" value={pos ? pos.city ? pos.city : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), city: e.target.value}))
                  }}
              />
            </Col>
            <Col md="4" xs="12">
              <Label>Provincia</Label>
              <Input type="text" id="province" name="province" placeholder="Province" value={pos ? pos.province ? pos.province : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), province: e.target.value}))
                  }}
              />
            </Col>
            <Col md="4" xs="12">
              <Label>Regione</Label>
              <Input type="text" id="state" name="state" placeholder="State" value={pos ? pos.state ? pos.state : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), state: e.target.value}))
                  }}
              />
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="4" xs="12">
              <Label>Ragione sociale</Label>
              <Input type="text" id="company_name" name="company_name" placeholder="Ragione sociale" value={pos ? pos.company_name ? pos.company_name : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), company_name: e.target.value}))
                  }}
              />
            </Col>
            <Col md="4" xs="12">
              <Label>Email PdV</Label>
              <Input type="text" id="email" name="email" placeholder="Email PdV" value={pos ? pos.email ? pos.email : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), email: e.target.value}))
                  }}
              />
              {showServerErrors("email")}
            </Col>
            <Col md="4" xs="12">
              <Label>Telefono PdV</Label>
              <Input type="text" id="phone" name="phone" placeholder="Telefono PdV" value={pos ? pos.phone ? pos.phone : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), phone: e.target.value}))
                  }}
              />
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="4" xs="12">
              <Label>Nome imprenditore</Label>
              <Input type="text" id="owner_name" name="owner_name" placeholder="Nome imprenditore" value={pos ? pos.owner_name ? pos.owner_name : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), owner_name: e.target.value}))
                  }}
              />
            </Col>
            <Col md="4" xs="12">
              <Label>Email imprenditore</Label>
              <Input type="text" id="owner_email" name="owner_email" placeholder="Email imprenditore" value={pos ? pos.owner_email ? pos.owner_email : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), owner_email: e.target.value}))
                  }}
              />
              {showServerErrors("owner_email")}
            </Col>
            <Col md="4" xs="12">
              <Label>Telefono imprenditore</Label>
              <Input type="text" id="owner_phone" name="owner_phone" placeholder="Telefono imprenditore" value={pos ? pos.owner_phone ? pos.owner_phone : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), owner_phone: e.target.value}))
                  }}
              />
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="4" xs="12">
              <Label>Nome referente</Label>
              <Input type="text" id="manager_name" name="manager_name" placeholder="Nome referente" value={pos ? pos.manager_name ? pos.manager_name : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), manager_name: e.target.value}))
                  }}
              />
            </Col>
            <Col md="4" xs="12">
              <Label>Telefono referente</Label>
              <Input type="text" id="manager_phone" name="manager_phone" placeholder="Telefono referente" value={pos ? pos.manager_phone ? pos.manager_phone : "" : ""} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), manager_phone: e.target.value}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>STRUTTURA</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="3" xs="12">
              <Label>Area di vendita (mq)</Label>
              <Input type="number" id="mq_sales_area" name="mq_sales_area" placeholder="Area di vendita (mq)" value={pos ? pos.mq_sales_area ? pos.mq_sales_area : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mq_sales_area: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="3" xs="12">
              <Label>Magazzino (mq)</Label>
              <Input type="number" id="mq_store" name="mq_store" placeholder="Magazzino (mq)" value={pos ? pos.mq_store ? pos.mq_store : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mq_store: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12" className="pt-3">
              <br/>
              {/* <CustomInput type="checkbox" id="shopping_center" name="shopping_center" label="Centro commerciale" checked={pos ? pos.shopping_center ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), shopping_center: e.target.checked}))
                }}
              /> */}
              <Input type="checkbox" id="shopping_center" name="shopping_center" style={ckBoxStyle} checked={pos ? pos.shopping_center ? true : false : false} 
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), shopping_center: e.target.checked}))
                }}
              />
              <Label>Centro commerciale</Label>
            </Col>
            <Col md="2" xs="12" className="pt-3">
              <br/>
              {/* <CustomInput type="checkbox" id="uncovered_parking" name="uncovered_parking" label="Parcheggio scoperto" checked={pos ? pos.uncovered_parking ? true : false : false} 
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), uncovered_parking: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="uncovered_parking" name="uncovered_parking" style={ckBoxStyle} checked={pos ? pos.uncovered_parking ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), uncovered_parking: e.target.checked}))
                }}
              />
              <Label>Parcheggio scoperto</Label>
            </Col>
            <Col md="2" xs="12" className="pt-3">
              <br/>
              {/* <CustomInput type="checkbox" id="covered_parking" name="covered_parking" label="Parcheggio coperto" checked={pos ? pos.covered_parking ? true : false : false} 
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), covered_parking: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="covered_parking" name="covered_parking" style={ckBoxStyle} checked={pos ? pos.covered_parking ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), covered_parking: e.target.checked}))
                }}
              />
              <Label>Parcheggio coperto</Label>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Num. casse</Label>
              <Input type="number" id="num_checkouts" name="num_checkouts" placeholder="Num. casse" value={pos ? pos.num_checkouts ? pos.num_checkouts : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_checkouts: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Num. bilance</Label>
              <Input type="number" id="num_scales" name="num_scales" placeholder="Num. bilance" value={pos ? pos.num_scales ? pos.num_scales : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_scales: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Num. addetti</Label>
              <Input type="number" id="num_employees" name="num_employees" placeholder="Num. addetti" value={pos ? pos.num_employees ? pos.num_employees : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_employees: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Location value</Label>
              <Input type="select" id="location_value" value={pos ? pos.location_value ? pos.location_value : 0 : 0}
                onChange={(e) => dispatch(setPos({...pos, id: parseInt(id), location_value: parseInt(e.target.value)})) } >
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
              </Input>
            </Col>
            <Col md="2" xs="12">
              <Label>Livello di professionalità</Label>
              <Input type="select" id="professional_level" value={pos ? pos.professional_level ? pos.professional_level : 0 : 0} 
                onChange={(e) => dispatch(setPos({...pos, id: parseInt(id), professional_level: parseInt(e.target.value)}))} >
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
              </Input>
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>REPARTI TRATTATI</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_bakery" name="dep_bakery" label="Panetteria" checked={pos ? pos.dep_bakery ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_bakery: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_bakery" name="dep_bakery" style={ckBoxStyle} checked={pos ? pos.dep_bakery ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_bakery: e.target.checked}))
                }}
              />
              <Label>Panetteria</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_canned" name="dep_canned" label="Scatolame" checked={pos ? pos.dep_canned ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_canned: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_canned" name="dep_canned" style={ckBoxStyle} checked={pos ? pos.dep_canned ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_canned: e.target.checked}))
                }}
              />
              <Label>Scatolame</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_cleaning" name="dep_cleaning" label="Detergenza" checked={pos ? pos.dep_cleaning ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_cleaning: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_cleaning" name="dep_cleaning" style={ckBoxStyle} checked={pos ? pos.dep_cleaning ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_cleaning: e.target.checked}))
                }}
              />
              <Label>Detergenza</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_dls" name="dep_dls" label="Dls" checked={pos ? pos.dep_dls ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_dls: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_dls" name="dep_dls" style={ckBoxStyle} checked={pos ? pos.dep_dls ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_dls: e.target.checked}))
                }}
              />
              <Label>Dls</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_fish" name="dep_fish" label="Pescheria" checked={pos ? pos.dep_fish ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_fish: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_fish" name="dep_fish" style={ckBoxStyle} checked={pos ? pos.dep_fish ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_fish: e.target.checked}))
                }}
              />
              <Label>Pescheria</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_fruit" name="dep_fruit" label="Ortofrutta" checked={pos ? pos.dep_fruit ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_fruit: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_fruit" name="dep_fruit" style={ckBoxStyle} checked={pos ? pos.dep_fruit ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_fruit: e.target.checked}))
                }}
              />
              <Label>Ortofrutta</Label>
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_frozen" name="dep_frozen" label="Surgelati" checked={pos ? pos.dep_frozen ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_frozen: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_frozen" name="dep_frozen" style={ckBoxStyle} checked={pos ? pos.dep_frozen ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_frozen: e.target.checked}))
                }}
              />
              <Label>Surgelati</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_frozen_bulk" name="dep_frozen_bulk" label="Congelato sfuso" checked={pos ? pos.dep_frozen_bulk ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_frozen_bulk: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_frozen_bulk" name="dep_frozen_bulk" style={ckBoxStyle} checked={pos ? pos.dep_frozen_bulk ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_frozen_bulk: e.target.checked}))
                }}
              />
              <Label>Congelato sfuso</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_gastronomy" name="dep_gastronomy" label="Gastronomia" checked={pos ? pos.dep_gastronomy ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_gastronomy: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_gastronomy" name="dep_gastronomy" style={ckBoxStyle} checked={pos ? pos.dep_gastronomy ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_gastronomy: e.target.checked}))
                }}
              />
              <Label>Gastronomia</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_meat" name="dep_meat" label="Carni" checked={pos ? pos.dep_meat ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_meat: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_meat" name="dep_meat" style={ckBoxStyle} checked={pos ? pos.dep_meat ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_meat: e.target.checked}))
                }}
              />
              <Label>Carni</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_no_food" name="dep_no_food" label="No food" checked={pos ? pos.dep_no_food ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_no_food: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_no_food" name="dep_no_food" style={ckBoxStyle} checked={pos ? pos.dep_no_food ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_no_food: e.target.checked}))
                }}
              />
              <Label>No food</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_news" name="dep_news" label="Edicola" checked={pos ? pos.dep_news ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_news: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_news" name="dep_news" style={ckBoxStyle} checked={pos ? pos.dep_news ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_news: e.target.checked}))
                }}
              />
              <Label>Edicola</Label>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_restaurant_area" name="dep_restaurant_area" label="Area ristoro" checked={pos ? pos.dep_restaurant_area ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_restaurant_area: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_restaurant_area" name="dep_restaurant_area" style={ckBoxStyle} checked={pos ? pos.dep_restaurant_area ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_restaurant_area: e.target.checked}))
                }}
              />
              <Label>Area ristoro</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="dep_wine" name="dep_wine" label="Enoteca" checked={pos ? pos.dep_wine ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_wine: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="dep_wine" name="dep_wine" style={ckBoxStyle} checked={pos ? pos.dep_wine ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), dep_wine: e.target.checked}))
                }}
              />
              <Label>Enoteca</Label>
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>REPARTO SA.FO. (Mlt)</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="2" xs="12">
              <Label>Banco Sa.Fo.</Label>
              <Input type="number" id="ml_stand_sa_fo" name="ml_stand_sa_fo" placeholder="Banco Sa.Fo." value={pos ? pos.ml_stand_sa_fo ? pos.ml_stand_sa_fo : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_sa_fo: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Retrobanco</Label>
              <Input type="number" id="ml_stand_back" name="ml_stand_back" placeholder="Retrobanco" value={pos ? pos.ml_stand_back ? pos.ml_stand_back : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_back: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Banco pasticceria</Label>
              <Input type="number" id="ml_stand_pastry" name="ml_stand_pastry" placeholder="Banco pasticceria" value={pos ? pos.ml_stand_pastry ? pos.ml_stand_pastry : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_pastry: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Banco caldo</Label>
              <Input type="number" id="ml_stand_hot" name="ml_stand_hot" placeholder="Banco caldo" value={pos ? pos.ml_stand_hot ? pos.ml_stand_hot : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_hot: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Banco pane servito</Label>
              <Input type="number" id="ml_stand_bakery_served" name="ml_stand_bakery_served" placeholder="Banco pane servito" value={pos ? pos.ml_stand_bakery_served ? pos.ml_stand_bakery_served : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_bakery_served: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Banco pane self</Label>
              <Input type="number" id="ml_stand_bakery_self" name="ml_stand_bakery_self" placeholder="Banco pane self" value={pos ? pos.ml_stand_bakery_self ? pos.ml_stand_bakery_self : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_bakery_self: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Vasche fresco</Label>
              <Input type="number" id="ml_stand_fresh_tubs" name="ml_stand_fresh_tubs" placeholder="Vasche fresco" value={pos ? pos.ml_stand_fresh_tubs ? pos.ml_stand_fresh_tubs : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_fresh_tubs: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>REPARTO MACELLERIA (Mlt)</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Banco servito</Label>
              <Input type="number" id="ml_stand_meat_served" name="ml_stand_meat_served" placeholder="Banco servito" value={pos ? pos.ml_stand_meat_served ? pos.ml_stand_meat_served : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_meat_served: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Libero servizio (murale)</Label>
              <Input type="number" id="ml_stand_meat_wall" name="ml_stand_meat_wall" placeholder="Libero servizio (murale)" value={pos ? pos.ml_stand_meat_wall ? pos.ml_stand_meat_wall : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_meat_wall: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Banco takeaway</Label>
              <Input type="number" id="ml_stand_meat_takeaway" name="ml_stand_meat_takeaway" placeholder="Banco takeaway" value={pos ? pos.ml_stand_meat_takeaway ? pos.ml_stand_meat_takeaway : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_meat_takeaway: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Isola promo</Label>
              <Input type="number" id="ml_stand_meat_promo" name="ml_stand_meat_promo" placeholder="Isola promo" value={pos ? pos.ml_stand_meat_promo ? pos.ml_stand_meat_promo : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_meat_promo: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>REPARTO ORTOFRUTTA</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Murale fresco (mlt)</Label>
              <Input type="number" id="ml_stand_fruit_wall" name="ml_stand_fruit_wall" placeholder="Murale fresco (mlt)" value={pos ? pos.ml_stand_fruit_wall ? pos.ml_stand_fruit_wall : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_fruit_wall: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Piazza Orto (mq)</Label>
              <Input type="number" id="mq_stand_fruit_square" name="mq_stand_fruit_square" placeholder="Piazza Orto (mq)" value={pos ? pos.mq_stand_fruit_square ? pos.mq_stand_fruit_square : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mq_stand_fruit_square: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Isola Promo (mt)</Label>
              <Input type="number" id="mt_stand_fruit_promo" name="mt_stand_fruit_promo" placeholder="Isola Promo (mt)" value={pos ? pos.mt_stand_fruit_promo ? pos.mt_stand_fruit_promo : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_stand_fruit_promo: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>DLS (Mlt)</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Murale DLS (Mlt)</Label>
              <Input type="number" id="ml_stand_dls" name="ml_stand_dls" placeholder="Murale DLS (Mlt)" value={pos ? pos.ml_stand_dls ? pos.ml_stand_dls : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), ml_stand_dls: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Murale DLS (sviluppati)</Label>
              <Input type="number" id="mt_stand_dls_developed" name="mt_stand_dls_developed" placeholder="Murale DLS (sviluppati)" value={pos ? pos.mt_stand_dls_developed ? pos.mt_stand_dls_developed : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_stand_dls_developed: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Isola Promo</Label>
              <Input type="number" id="mt_stand_dls_promo" name="mt_stand_dls_promo" placeholder="Isola Promo" value={pos ? pos.mt_stand_dls_promo ? pos.mt_stand_dls_promo : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_stand_dls_promo: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>CELLE</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="cells_fresh" name="cells_fresh" label="Freschi" checked={pos ? pos.cells_fresh ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_fresh: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="cells_fresh" name="cells_fresh" style={ckBoxStyle} checked={pos ? pos.cells_fresh ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_fresh: e.target.checked}))
                }}
              />
              <Label>Freschi</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="cells_meat" name="cells_meat" label="Carne" checked={pos ? pos.cells_meat ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_meat: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="cells_meat" name="cells_meat" style={ckBoxStyle} checked={pos ? pos.cells_meat ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_meat: e.target.checked}))
                }}
              />
              <Label>Carne</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="cells_fruit" name="cells_fruit" label="Orto" checked={pos ? pos.cells_fruit ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_fruit: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="cells_fruit" name="cells_fruit" style={ckBoxStyle} checked={pos ? pos.cells_fruit ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_fruit: e.target.checked}))
                }}
              />
              <Label>Orto</Label>
            </Col>
            <Col md="2" xs="12">
              {/* <CustomInput type="checkbox" id="cells_free" name="cells_free" label="Libero servizio" checked={pos ? pos.cells_free ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_free: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="cells_free" name="cells_free" style={ckBoxStyle} checked={pos ? pos.cells_free ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), cells_free: e.target.checked}))
                }}
              />
              <Label>Libero servizio</Label>
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>Surgelati / Cong. Sfuso / Pescheria (Mlt)</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Murale congelati</Label>
              <Input type="number" id="mt_stand_frozen_wall" name="mt_stand_frozen_wall" placeholder="Murale congelati" value={pos ? pos.mt_stand_frozen_wall ? pos.mt_stand_frozen_wall : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_stand_frozen_wall: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Vasche surgelati (mlt)</Label>
              <Input type="number" id="num_stand_frozen_tubs" name="num_stand_frozen_tubs" placeholder="Vasche surgelati (mlt)" value={pos ? pos.num_stand_frozen_tubs ? pos.num_stand_frozen_tubs : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_stand_frozen_tubs: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Vasche surgelato sfuso (mlt)</Label>
              <Input type="number" id="num_stand_frozen_bulk_tubs" name="num_stand_frozen_bulk_tubs" placeholder="Vasche surgelato sfuso (mlt)" value={pos ? pos.num_stand_frozen_bulk_tubs ? pos.num_stand_frozen_bulk_tubs : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_stand_frozen_bulk_tubs: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Murale pescheria (mlt)</Label>
              <Input type="number" id="mt_stand_fish_wall" name="mt_stand_fish_wall" placeholder="Murale pescheria (mlt)" value={pos ? pos.mt_stand_fish_wall ? pos.mt_stand_fish_wall : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_stand_fish_wall: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Vasca pescheria (mlt)</Label>
              <Input type="number" id="num_stand_fish_tubs" name="num_stand_fish_tubs" placeholder="Vasca pescheria (mlt)" value={pos ? pos.num_stand_fish_tubs ? pos.num_stand_fish_tubs : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_stand_fish_tubs: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>SCAFFALATURA (Mlt)</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Scaffalatura (Mlt)</Label>
              <Input type="number" id="mt_shelf" name="mt_shelf" placeholder="Scaffalatura (Mlt)" value={pos ? pos.mt_shelf ? pos.mt_shelf : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>SCAFFALATURA (Metri Sviluppati)</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-2 pt-2">
            <Col md="2" xs="12">
              <Label>Scaffalatura 133</Label>
              <Input type="number" id="mt_shelf_133" name="mt_shelf_133" placeholder="Scaffalatura 133" value={pos ? pos.mt_shelf_133 ? pos.mt_shelf_133 : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf_133: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Scaffalatura 125</Label>
              <Input type="number" id="mt_shelf_125" name="mt_shelf_125" placeholder="Scaffalatura 125" value={pos ? pos.mt_shelf_125 ? pos.mt_shelf_125 : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf_125: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Scaffalatura 120</Label>
              <Input type="number" id="mt_shelf_120" name="mt_shelf_120" placeholder="Scaffalatura 120" value={pos ? pos.mt_shelf_120 ? pos.mt_shelf_120 : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf_120: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Scaffalatura 100</Label>
              <Input type="number" id="mt_shelf_100" name="mt_shelf_100" placeholder="Scaffalatura 100" value={pos ? pos.mt_shelf_100 ? pos.mt_shelf_100 : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf_100: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Scaffalatura 75</Label>
              <Input type="number" id="mt_shelf_75" name="mt_shelf_75" placeholder="Scaffalatura 75" value={pos ? pos.mt_shelf_75 ? pos.mt_shelf_75 : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf_75: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Scaffalatura 60</Label>
              <Input type="text" id="mt_shelf_60" name="mt_shelf_60" placeholder="Scaffalatura 60" value={pos ? pos.mt_shelf_60 ? pos.mt_shelf_60 : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf_60: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Scaffalatura 50</Label>
              <Input type="number" id="mt_shelf_50" name="mt_shelf_50" placeholder="Scaffalatura 50" value={pos ? pos.mt_shelf_50 ? pos.mt_shelf_50 : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_shelf_50: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>ACQUE</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Scaffalatura (mlt)</Label>
              <Input type="number" id="mt_water" name="mt_water" placeholder="Scaffalatura (mlt)" value={pos ? pos.mt_water ? pos.mt_water : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), mt_water: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12">
              <Label>Num. rack</Label>
              <Input type="number" id="num_water_rack" name="num_water_rack" placeholder="Num. rack" value={pos ? pos.num_water_rack ? pos.num_water_rack : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_water_rack: parseInt(e.target.value)}))
                  }}
              />
            </Col>
          </Row>
        </div>
        <div className="bg-white app-drawer-content mt-2">
          <Row className="px-4 pb-2 pt-4">
            <Col md="12" className="text-left">
              <h4>Tipo di mezzo compatibile per lo scarico</h4>
            </Col>
          </Row>
          <Row className="px-4 pb-4 pt-2">
            <Col md="2" xs="12">
              <Label>Num. piattaforme di carico</Label>
              <Input type="number" id="num_loading_platform" name="num_loading_platform" placeholder="Num. piattaforme di carico" value={pos ? pos.num_loading_platform ? pos.num_loading_platform : 0 : 0} 
                  onChange={(e) => {
                    dispatch(setPos({...pos, id: parseInt(id), num_loading_platform: parseInt(e.target.value)}))
                  }}
              />
            </Col>
            <Col md="2" xs="12" className="pt-3">
              <br/>
              {/* <CustomInput type="checkbox" id="night_loading_enabled" name="night_loading_enabled" label="Scarico notturno" checked={pos ? pos.night_loading_enabled ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), night_loading_enabled: e.target.checked}))
                }}
              /> */}
              <Input type="switch" id="night_loading_enabled" name="night_loading_enabled" style={ckBoxStyle} checked={pos ? pos.night_loading_enabled ? true : false : false}
                onChange={(e) => {
                  dispatch(setPos({...pos, id: parseInt(id), night_loading_enabled: e.target.checked}))
                }}
              />
              <Label>Scarico notturno</Label>
            </Col>
          </Row>
        </div>
    </div>
  );
};

export default PointOfSale;